import { createContext, FC, useCallback, useState } from 'react';

export interface BackgroundConfig {
  deskImage: string;
  mobImage?: string;
  deskPositionX?: string;
  deskSize?: string;
  mobSize?: string;
  mobPositionX?: string;
}

interface BackgroundContextData {
  backgroundConfig?: BackgroundConfig;
}

interface BackgroundContextActions {
  handleChangeBackgroundConfig: (config?: BackgroundConfig) => void;
}

export const BackgroundContext = createContext<
  BackgroundContextData & BackgroundContextActions
>(null as any);

export const BackgroundContextProvider: FC = ({ children }) => {
  const [backgroundConfig, setBackgroundConfig] = useState<BackgroundConfig>();

  const handleChangeBackgroundConfig = useCallback(
    (config?: BackgroundConfig) => {
      setBackgroundConfig(config);
    },
    [setBackgroundConfig]
  );

  return (
    <BackgroundContext.Provider
      value={{
        handleChangeBackgroundConfig,
        backgroundConfig,
      }}
    >
      {children}
    </BackgroundContext.Provider>
  );
};
